<template>
  <div
    id="page-share"
    class="d-flex flex-column"
    :class="{
      'connected': roomConnected
    }"
  >
    <GlobalEvents
      target="window"
      @dragover.prevent
      @drop.prevent
    />

    <LegacyWarningDialog />
    <Topbar @roomInviteUser="$refs.roomInviteUser.show()" />

    <Peers v-if="roomConnected" />
    <NotConnected v-else />
    <PeersSelf />

    <RoomsDialog ref="rooms" @rooms="rooms = $event" />
    <RoomCreateDialog :rooms="rooms" />
    <RoomUpdateDialog
      ref="updateRoom"
      @loading="loading = $event"
      @loading-delete="loading_delete = $event"
    >
      <v-btn
        class="text-center mt-4"
        color="error"
        depressed
        rounded
        large
        block
        :loading="loading_delete"
        :disabled="loading"
        @click="_deleteRoom"
      >
        Raum löschen
      </v-btn>
    </RoomUpdateDialog>
    <RoomInviteUserDialog ref="roomInviteUser" />
    <RoomChangeConfirmDialog />

    <ShareFiles v-if="room && room.id !== 'local'" />
    <Notifications />

    <template v-if="room">
      <FilesSendDialog />
      <FilePublicShareDialog />
      <TextSendDialog />
    </template>

    <NetworkStatus />

    <Prompt />

    <Sounds />

    <div class="circles">
      <svg viewBox="-0.5 -0.5 1140 700">
        <circle
          v-for="(r, i) in [30, 80, 160, 280, 400, 520]"
          :key="i"
          class="circle"
          cx="570"
          cy="570"
          :r="r"
        ></circle>
      </svg>
    </div>

    <Tour />
  </div>
</template>

<script>
  import GlobalEvents from 'vue-global-events';
  import Favico from 'favico.js';

  import Network from '../assets/js/network';
  import {setDocumentTitle} from '../assets/js/document-title';

  // Components
  import Topbar from '../components/Topbar';
  import * as Dialogs from '../components/dialogs';
  import ShareFiles from '../components/ShareFiles';
  import Notifications from '../components/Notifications';
  import Peers from '../components/peers';
  import PeersSelf from '../components/peers/PeerSelf';
  import NotConnected from '../components/NotConnected';
  import NetworkStatus from '../components/NetworkStatus';
  import Prompt from '../components/Prompt';
  import Sounds from '../components/Sounds';
  import Tour from '../components/tour/Tour';



  export default {
    name: 'Share',

    components: {
      GlobalEvents,
      Topbar,
      ...Dialogs,
      ShareFiles,
      Notifications,
      Peers,
      PeersSelf,
      NotConnected,
      NetworkStatus,
      Prompt,
      Sounds,
      Tour
    },

    data() {
      return {
        rooms: [],
        loading: false,
        loading_delete: false
      };
    },

    computed: {
      room() {
        return this.$store.getters['share/getRoom'];
      },

      roomConnected() {
        return this.$store.getters['share/getRoomConnected'];
      },

      notifications() {
        return this.$store.getters['share/getNotifications'];
      },

      documentTitle() {
        const {room} = this;
        return room ? room.name : null;
      }
    },

    watch: {
      documentTitle(documentTitle) {
        this.$emit('documentTitle', documentTitle);
      },

      'notifications.length'(notifications = this.notifications.length) {
        this._revertDocumentTitle();
        if (!notifications) {
          return;
        }

        this.favico.badge(notifications);
        const unreadTitle = this.$tc('unreadNotifications', notifications);
        setDocumentTitle(unreadTitle);
        this._unreadTitleInterval = setInterval(() => {
          setDocumentTitle(this.documentTitle);
          this._unreadTitleTimeout = setTimeout(() => setDocumentTitle(unreadTitle), 3000);
        }, 6000);
      }
    },

    async mounted() {
      this.network = new Network();

      this.favico = new Favico({
        position: 'up',
        animation: 'popFade'
      });

      this.$options.watch['notifications.length'].call(this);
    },

    async beforeDestroy() {
      if (this.network) {
        this.network.close();
      }
      this._revertDocumentTitle();
    },

    methods: {
      _deleteRoom() {
        this.$refs.updateRoom.delete();
      },

      _revertDocumentTitle() {
        this.favico.reset();
        clearInterval(this._unreadTitleInterval);
        clearTimeout(this._unreadTitleTimeout);
        setDocumentTitle(this.documentTitle);
      }
    }
  };
</script>

<style lang="scss">
  @import '../assets/scss/share.scss';
</style>
